import { render, staticRenderFns } from "./ListaFbLeads.vue?vue&type=template&id=5b76daa4"
import script from "./ListaFbLeads.vue?vue&type=script&lang=js"
export * from "./ListaFbLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports